import { render, staticRenderFns } from "./CardReceipt.vue?vue&type=template&id=79f008ec&scoped=true&"
import script from "./CardReceipt.vue?vue&type=script&lang=js&"
export * from "./CardReceipt.vue?vue&type=script&lang=js&"
import style0 from "./CardReceipt.vue?vue&type=style&index=0&id=79f008ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f008ec",
  null
  
)

export default component.exports